(function () {
  'use strict';

  function createHeadingId(heading, index) {
    var existing = heading.getAttribute('id');
    if (existing) return existing;

    var slug = (heading.textContent || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\u00c0-\u024f\u4e00-\u9fff]+/g, '-')
      .replace(/^-+|-+$/g, '');

    heading.id = 'article-section-' + (slug || index + 1);
    return heading.id;
  }

  function initBlog(root) {
    var input = root.querySelector('[data-odx-search]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-odx-card]'));
    var empty = root.querySelector('[data-odx-empty]');
    var count = root.querySelector('[data-odx-result-count]');

    if (!cards.length) return;

    function update() {
      var query = input ? input.value.trim().toLowerCase() : '';
      var visibleCount = 0;

      cards.forEach(function (card) {
        var searchText = (card.getAttribute('data-search') || '').toLowerCase();
        var visible = !query || searchText.indexOf(query) !== -1;

        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (empty) empty.classList.toggle('is-visible', visibleCount === 0);
      if (count) {
        count.textContent = query
          ? String(visibleCount)
          : (count.getAttribute('data-odx-total-count') || String(visibleCount));
      }
    }

    if (input) input.addEventListener('input', update);
    update();
  }

  function populateToc(root, content) {
    var desktop = root.querySelector('[data-odx-desktop-toc]');
    var mobile = root.querySelector('[data-odx-mobile-toc]');
    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));

    if (!headings.length) return [];

    var displayedHeadings = headings.slice(0, 7);
    var desktopLinks = [];

    displayedHeadings.forEach(function (heading, index) {
      var id = createHeadingId(heading, index);

      if (desktop) {
        var desktopLink = document.createElement('a');
        desktopLink.href = '#' + id;
        desktopLink.textContent = heading.textContent.trim();
        desktop.appendChild(desktopLink);
        desktopLinks.push(desktopLink);
      }

      if (mobile) {
        var mobileLink = document.createElement('a');
        mobileLink.href = '#' + id;
        mobileLink.textContent = heading.textContent.trim();
        mobile.appendChild(mobileLink);
      }
    });

    if ('IntersectionObserver' in window && desktopLinks.length) {
      var linkById = {};
      desktopLinks.forEach(function (link) {
        linkById[decodeURIComponent(link.hash.slice(1))] = link;
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          desktopLinks.forEach(function (link) { link.classList.remove('is-active'); });
          var active = linkById[entry.target.id];
          if (active) active.classList.add('is-active');
        });
      }, { rootMargin: '-18% 0px -70% 0px', threshold: 0 });

      displayedHeadings.forEach(function (heading) { observer.observe(heading); });
    }

    return headings;
  }

  function placeContextualProduct(root, content, headings) {
    var product = root.querySelector('[data-odx-contextual-product]');
    if (!product || headings.length < 4) return;
    content.insertBefore(product, headings[3]);
  }

  function initCopyLink(root) {
    var button = root.querySelector('[data-odx-copy-link]');
    var status = root.querySelector('[data-odx-copy-status]');
    if (!button) return;

    button.addEventListener('click', function () {
      var url = button.getAttribute('data-url') || window.location.href;
      var copyPromise;

      if (navigator.clipboard && window.isSecureContext) {
        copyPromise = navigator.clipboard.writeText(url);
      } else {
        var textarea = document.createElement('textarea');
        textarea.value = url;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          copyPromise = Promise.resolve();
        } catch (error) {
          copyPromise = Promise.reject(error);
        }
        document.body.removeChild(textarea);
      }

      copyPromise.then(function () {
        if (status) status.textContent = 'Link copied';
        window.setTimeout(function () {
          if (status) status.textContent = '';
        }, 2200);
      }).catch(function () {
        if (status) status.textContent = 'Copy failed';
      });
    });
  }

  function initReadingProgress(root) {
    var progress = root.querySelector('[data-odx-reading-progress]');
    if (!progress) return;

    function updateProgress() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var maximum = document.documentElement.scrollHeight - window.innerHeight;
      var ratio = maximum > 0 ? Math.min(1, Math.max(0, scrollTop / maximum)) : 0;
      progress.style.transform = 'scaleX(' + ratio + ')';
    }

    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  }

  function initArticle(root) {
    var content = root.querySelector('[data-odx-article-content]');
    if (!content) return;

    populateToc(root, content);
    initCopyLink(root);
    initReadingProgress(root);
  }

  function init() {
    document.querySelectorAll('[data-odx-blog]').forEach(initBlog);
    document.querySelectorAll('[data-odx-article]').forEach(initArticle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
